export const selectUser = (state) => state.auth.user
export const selectIsLoggedIn = (state) => !!state.auth.user